
export default {
    data() {
        return {

        };
    },
    methods: {
        parseAndFormatWarningOverlaps: function (warning, schedule) {
            let text = schedule.name + ' has overlap by ' + warning.type + ' with <a target="_blank" href="' + warning.link + '">' + warning.name + '</a>';

            return text;
        },
        parseAndFormatSchedule: function (row, urls) {
            let s = {
                id: row.id,
                calendarId: '1',
                body: '',
                location: row.location,
                location_id: row.location_id,
                category: 'time',
                start: row.start,
                end: row.end,
                isReadOnly: true
            };

            s.color = '#000000';

            if (row.comments) {
                s.body = '<p><em>' + row.comments + '</em></p>';
            }



            if (row.is_finished) {
                s.color = '#666666';
            } else {
                if (row.users) {
                    row.capacity = parseInt(row.capacity);
                    if (row.users.length >= row.capacity * 0.8) {
                        s.color = '#ff0000';
                    } else {
                        s.color = '#0000dd';
                    }
                    s.attendees = [];
                    _.forEach(row.users, function (u) {
                        s.attendees.push(u.name);
                    });
                    if (row.capacity > 0) {
                        s.body = s.body + '<p>' + row.users.length + ' users of ' + row.capacity + ' capacity</p>';
                    }
                }
            }

            row.price = parseInt(row.price);
            if (row.price > 0) {
                row.price = parseInt(row.price);
                s.body = s.body + '<p>Price $' + row.price + '.00</p>';
            }

            if (row.trainer) {
                s.state = row.trainer.name;
                if (row.trainer.color) {
                    if (row.is_finished) {
                        s.bgColor = pSBC(0.8, row.trainer.color, false, true);
                    } else {
                        s.bgColor = pSBC(0.6, row.trainer.color, false, true);
                    }

                    //s.bgColor = row.trainer.color;
                }
            }

            if (row.course) {
                s.title = row.course.name;
                if (row.course.color) {
                    s.borderColor = row.course.color;
                }
                if (row.location) {
                    s.title = s.title + ' [' + row.location + ']';
                }
            } else {
                s.title = '#' + row.id
            }
            if (row.is_recurring) {
                s.recurrenceRule = 'Recurring';
            }
            s.body = s.body + '<p>';
            s.body = s.body + '<a href="' + urls.view.replace('__ID__', row.id) + '" class="btn btn-info btn-sm" target="_blank">show</a> ';
            if (row.auth.is_updatable) {
                s.body = s.body + ' <a href="' + urls.edit.replace('__ID__', row.id) + '" class="btn btn-warning btn-sm" target="_blank">edit</a> ';
            }
            if (row.auth.is_cancelable) {
                s.body = s.body + '<a href="' + urls.cancel.replace('__ID__', row.id) + '" class="btn btn-danger btn-sm float-lg-right" target="_blank" onclick="return confirm(\'Are you sure? It will cancel only this schedule! If you want to change the rule, edit it at course page\')">cancel this schedule</a>';
            }
            s.body = s.body + '</p>';

            if (!row.is_active) {
                s.color = pSBC(0.5, s.color, false, true);
                s.bgColor = pSBC(0.5, s.bgColor, false, true);
            }

            if (row.has_event_conflict) {
                s.body = s.body + '<p><em class="text-danger">has conflict</em></p>';
                s.title = '☝ ' + s.title;
                s.color = '#FFAC1B';
            }

            if (row.schedule_conflict_count && row.schedule_conflict_count > 0) {
                s.body = s.body + '<p><em class="text-danger">has ' + row.schedule_conflict_count + ' schedule conflicts</em></p>';
                s.title = '⚡ ' + s.title;
                s.color = '#FFAC1B';
            }

            return s;
        },
        parseAndFormatSchedules: function (data, urls) {
            let scheduleList = [];
            let t = this;
            _.forEach(data, function (row) {
                let s = t.parseAndFormatSchedule(row, urls)
                scheduleList.push(s);
            });

            return scheduleList;
        },
    }
}
